import { Checkbox, FormControlLabel, Typography } from '@mui/material';

interface Props {
  agreedToTerms: boolean;
  onAgreedToTermsChange: (checked: boolean) => void;
  includePlatformFees?: boolean;
}

const RetainerAgreementCheckbox = ({
  agreedToTerms,
  onAgreedToTermsChange,
  includePlatformFees = false,
}: Props) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={agreedToTerms}
        onChange={(e) => onAgreedToTermsChange(e.target.checked)}
      />
    }
    label={
      <Typography variant="body2">
        I have read and agree to the retainer terms
        {includePlatformFees ? ' and platform fees' : ''} for this matter. Both
        parties must agree before the retainer can be funded.
      </Typography>
    }
  />
);

export default RetainerAgreementCheckbox;
